import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FadeInSection from '../FadeInSection';
import { motion } from 'framer-motion';

function Investment() {
  // Animation variants for staggered fade-in
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <FadeInSection>
      <div className='px-6 sm:px-24 py-20 bg-primary-color5'>
        <div className='sm:flex gap-5'>
          {/* Heading */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h1 className='text-[24px] text-primary-color font-[400] mb-4 sm:text-[44px]'>
              Investment
            </h1>
          </motion.div>

          {/* Accordion List with staggered animation */}
          <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="flex-1"
          >
            <motion.div variants={itemVariants}>
              <Accordion elevation={0} style={{ backgroundColor: 'transparent' }} sx={{ '&:before': { display: 'none' } }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                  <Typography>
                    <h1 className='text-[16px] sm:text-[24px] font-[400] text-text-color1'>
                      1. What is Islamic investment on Halal Wealth?
                    </h1>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <p className='text-[16px] sm:text-[24px] text-text-color1 font-normal'>
                      Islamic investment on Halal Wealth follows principles that align with Islamic finance, avoiding interest-based transactions and adhering to ethical guidelines.
                    </p>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </motion.div>

            <motion.div variants={itemVariants}>
              <Accordion elevation={0} style={{ backgroundColor: 'transparent' }} sx={{ '&:before': { display: 'none' } }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                  <Typography>
                    <h1 className='text-[16px] sm:text-[24px] font-[400] text-text-color1'>
                      2. How do I start investing on Halal Wealth?
                    </h1>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <p className='text-[16px] sm:text-[24px] text-text-color1 font-normal'>
                      To start investing, log in to your account, choose the "Investment" section, and select an investment portfolio that matches your goals and risk tolerance. Follow the on-screen instructions to fund your investment.
                    </p>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </motion.div>

            <motion.div variants={itemVariants}>
              <Accordion elevation={0} style={{ backgroundColor: 'transparent' }} sx={{ '&:before': { display: 'none' } }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header">
                  <Typography>
                    <h1 className='text-[16px] sm:text-[24px] font-[400] text-text-color1'>
                      3. Can I withdraw my investments at any time?
                    </h1>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <p className='text-[16px] sm:text-[24px] text-text-color1 font-normal'>
                      Yes, you can withdraw funds from your investments at any time, subject to the terms and conditions of the specific investment portfolio you've chosen.
                    </p>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </motion.div>

            <motion.div variants={itemVariants}>
              <Accordion elevation={0} style={{ backgroundColor: 'transparent' }} sx={{ '&:before': { display: 'none' } }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4a-content" id="panel4a-header">
                  <Typography>
                    <h1 className='text-[16px] sm:text-[24px] font-[400] text-text-color1'>
                      4. What kind of returns can I expect from my investments?
                    </h1>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <p className='text-[16px] sm:text-[24px] text-text-color1 font-normal'>
                      Returns on investments vary depending on the portfolio's strategy and market conditions. You can find expected returns and risk profiles in the portfolio details.
                    </p>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </FadeInSection>
  )
}

export default Investment
